module.exports = __webpack_public_path__ + "img/content-not-found-light.593515b.svg";